import createId from './createId'
import defaultValue from './defaultValue'
import downloadFile from './downloadFile'
import log from './log'
import mapping from './mapping'

const utils = {
  mapping,
  log,
  downloadFile,
  createId,
  defaultValue
}

export default utils
